// @flow
import React from "react"
import { Redirect } from "react-router-dom"
import { compose, type HOC } from "recompose"
import withConnect from "hoc/withConnect"
import withUser from "hoc/withUser"
import withQuery from "hoc/withQuery"
import { listCountriesPerProductGroupQuery } from "data/locations/queries"
import type { Activity } from "data/app/types"
import type { ProductGroupCountryAggregator } from "data/locations/types"
import type { User } from "data/user/types"
import Activities from "components/Activities"
import SpecialPage from "pages/_Page/SpecialPage"
import urls from "data/router/urls"
import { chooseActivity } from "data/app/actions"
import { selectActivity } from "data/app/selectors"
import { StyledTitle } from "./styled"
import {
  getProductGroups,
  getLocationsNumberPerProductGroup,
} from "./helpers"

type Props = {
  activity: Activity,
  chooseActivity: typeof chooseActivity,
  data: ProductGroupCountryAggregator[],
  user: User,
}

const ExplorePage = ({ activity, chooseActivity, data, user }: Props) => {
  if (activity) return <Redirect to={urls.products} />

  const locationsPerActivity = getLocationsNumberPerProductGroup(data)
  const productGroups = getProductGroups(locationsPerActivity)

  return (
    <SpecialPage fixed>
      <StyledTitle>Explore awayco</StyledTitle>
      <br /><br />
      <StyledTitle>Ocean</StyledTitle>
      <Activities
        onChange={chooseActivity}
        user={user}
        activity={productGroups.ocean}
      />
      <br /><br />
      <StyledTitle>Mountain</StyledTitle>
      <Activities
        onChange={chooseActivity}
        user={user}
        activity={productGroups.mountain}
      />
      <br /><br />
      <StyledTitle>Wheels</StyledTitle>
      <Activities
        onChange={chooseActivity}
        user={user}
        activity={productGroups.wheels}
      />
    </SpecialPage>
  )
}

const mapStateToProps = state => ({
  activity: selectActivity(state),
})

const mapDispatchToProps = {
  chooseActivity,
}

const enhancer: HOC<*, Props> = compose(
  withUser(),
  withConnect(mapStateToProps, mapDispatchToProps),
  withQuery(listCountriesPerProductGroupQuery),
)

export default enhancer(ExplorePage)



// WEBPACK FOOTER //
// ./src/pages/Explore/index.js